import axios from "axios";
import { utils } from "../utils/Utils";
async function AsyncAjaxPost(Url, data, access_token, callback, onFailure, merchantid, userid, apiGrp) {
  window.VagaroCoreApiUrl = process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp)
  //window.VagaroCoreApiUrl = apiGrp.toLowerCase() === "us02" ? process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp).replace("api.vagaro.com", "as-prod-us02-apiv2-merchant.azurewebsites.net") : process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp);
  const APIURL = window.VagaroCoreApiUrl + Url;
  let header = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + access_token,
    ...(utils.Validate(merchantid) && { 'merchantId': merchantid }),
    ...(utils.Validate(userid) && { 'userId': userid }),
  };

  await axios.post(APIURL, data, { headers: header })
    .then((response) => { callback(response) })
    .catch((error) => { onFailure(error) });
};

async function AjaxGenerateToken(Url, data, callback, onFailure, apiGrp) {
  window.VagaroCoreApiUrl = process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp)
  //window.VagaroCoreApiUrl = apiGrp.toLowerCase() === "us02" ? process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp).replace("api.vagaro.com", "as-prod-us02-apiv2-merchant.azurewebsites.net") : process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", apiGrp);
  const APIURL = window.VagaroCoreApiUrl + Url;
  const header = {
    "Content-Type": "application/json",
  };
  await axios.post(APIURL, data, { headers: header })
    .then((response) => { callback(response) })
    .catch((error) => { onFailure(error) });
};

export { AsyncAjaxPost, AjaxGenerateToken };
